import type { FC } from "react";

export const SiteFooter: FC = () => (
  <footer data-print-hide className="mt-auto border-neutral-200 border-t bg-white py-3">
    <div className="mx-auto w-full max-w-2xl px-5 text-center text-neutral-500 text-xs">
      <p>&copy; {new Date().getFullYear()} Survaq Inc.</p>
    </div>
  </footer>
);
